export default "__VITE_ASSET__aO6ZQCFj__"